import React, { useEffect, useState } from "react";
import { Grid } from '@mui/material'
import ButtonsGroup from '../../../components/Custom/ButtonsGroup'
import ThemeColor from "../../../theme/ThemeColor";
import { useNavigate } from "react-router-dom";
import PickupAllocated from "./PickupAllocated";
import PickupPending from "./PickupPending";

const CreateFromPickup = () => {
    const navigate = useNavigate()
    // const [role, setRole] = useState(localStorage.getItem("role"));
    let headerName = "Pickup";
    const buttonName = ["Pending", "Allocated"]
    const [activeButton, setActiveButton] = useState(buttonName[0]);
    const [renderedComponent, setRenderedComponent] = useState(null);
    const [pagepath, setPagepath] = useState(false)


    useEffect(() => {
        if (activeButton === 'Pending') {
            setRenderedComponent(<PickupPending />)
            setPagepath('Pages / OfficeAdmin/Pickup/ CreateFormPickup')
        }
    }, [activeButton])

    const handleClick = (name) => {
        setActiveButton(name);
        switch (name) {
            case 'Pending':
                setRenderedComponent(<PickupPending />)
                setPagepath('Pages / OfficeAdmin/Pickup/ CreateFormPickup')
                break;
            case 'Allocated':
                 setRenderedComponent(<PickupAllocated/>)
                setPagepath('Pages / OfficeAdmin/Pickup/ CreateFormPickup')
                break;


            case 'refresh':
                window.location.reload();

                break;

            default:
                setRenderedComponent(null)
                break;

        }
    };
    const showButtons = () => { }
    return (
        <>

            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                {/* <NavbarTop PagePath={pagepath} />
                <Navbar title={headerName} showButtons={showButtons}
                    onClickBackButton={() => navigate("/dashboard")} deleteOption = {false} handleAutoRenewClick={() => handleClick("refresh")} /> */}

                <Grid item xs={12} md={8} sm={12} lg={12} style={{ backgroundColor: 'transaprent', border: '1px solid #FFFFF', borderRadius: '30px',  }}>
                    <div style={{ maxWidth: '500px', padding: '0px 0px 0px 0px', overflowX: 'auto', overflowY: 'auto', whiteSpace: 'nowrap' }}>
                        {buttonName.map((name, index) => (
                            <ButtonsGroup
                                key={index}
                                onClick={() => handleClick(name)}
                                text={name}
                                backgroundColor={ThemeColor.palette.ButtonColor}
                                isActive={name === activeButton}
                            />
                        ))}

                    </div>

                    {renderedComponent}

                </Grid>
            </div>
        </>
    )
}

export default CreateFromPickup
